import { Cart } from '@/page-content/cart/ui';

import { MainLayout } from '@/widgets/layouts/main';

import { PageSeo } from '@/shared/lib/seo';

export default function CartPage() {
  return (
    <>
      <PageSeo
        title="корзина"
        description="Корзина Азимут. Надежный поставщик качественного строительного крепежа торговых марок RAWLPLUG, ELEMENTA, GRAF, FISCHER в Омске."
      />
      <Cart />;
    </>
  );
}

CartPage.Layout = MainLayout;
